<template>
  <div class="gWidth">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="sticky">
      <!-- <el-tab-pane label="全部" :name="'0'"></el-tab-pane> -->
      <el-tab-pane label="全部" :name="''"></el-tab-pane>
      <el-tab-pane label="英超" :name="'36'"></el-tab-pane>
      <el-tab-pane label="德甲" :name="'8'"></el-tab-pane>
      <el-tab-pane label="意甲" :name="'34'"></el-tab-pane>
      <el-tab-pane label="西甲" :name="'31'"></el-tab-pane>
      <el-tab-pane label="法甲" :name="'11'"></el-tab-pane>
    </el-tabs>
    <div class="information_box" style="overflow: auto">
      <el-card v-for="(item, index) in news_l" :key="index">
        <div class="information cuP" @click="fnJumpDetailsPage(item.news_id)">
          <div class="information_l">
            <el-image :src="`http://oss.deyity.com/img/${item.cover_path}`">
              <template #error>
                <el-empty :image-size="50" description="空"></el-empty>
              </template>
            </el-image>
          </div>
          <div class="information_r">
            <h3>{{ item.title }}</h3>
            <p class="conter_s" v-html="item.content"></p>
            <p class="pp">
              <span>{{ item.public_time }}({{ item.reprinted }})</span>
              <span class="pp_span">
                <span><i class="el-icon-s-promotion"></i>转发</span>
                <span><i class="el-icon-star-on"></i>收藏</span>
              </span>
            </p>
          </div>
        </div>
      </el-card>
      <p v-if="loading" class="loading">加载中...</p>
      <p v-if="noMore" class="loading">没有更多了</p>
    </div>
  </div>
</template>
<script>
import { ref, getCurrentInstance, onUnmounted } from "vue";
import { useRouter } from "vue-router";

export default {
  setup() {
    let { proxy: _this } = getCurrentInstance();
    let router = useRouter();
    let activeName = ref("");
    // let sclass_ids = ''
    let handleClick = (v) => {
      console.log(v.props.name);
      activeName.value = v.props.name;
      pages.value = 1;
      news_l.value = [];
      load();
    };
    // 初始全部新闻
    let loading = ref(true);
    let noMore = ref(false);
    let pages = ref(1);
    let news_l = ref([]);
    let soccer_news = async () => {
      let obj = { page: pages.value, sclass_id: activeName.value };
      let { data: res } = await _this.$http.get("/news/soccer", {
        params: obj,
      });
      if (res.data.length === 0) {
        loading.value = false;
        noMore.value = true;
        _this.$notify({
          title: "提示",
          message: "已加载全部内容",
          type: "error",
        });
      }
      news_l.value = news_l.value.concat(
        ...JSON.parse(JSON.stringify(res.data))
      );
    };
    // 无限滚动
    const load = () => {
      soccer_news();
      pages.value++;
    };
    let onscrolla = () => {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight >= scrollHeight) {
        //到了这个就可以进行业务逻辑加载后台数据了
        load();
      }
    };
    window.addEventListener("scroll", onscrolla);
    load();

    // 跳转详情页
    let fnJumpDetailsPage = (new_id) => {
      let routeUrl = router.resolve({
        path: `/new/detail/${new_id}`,
      });
      window.open(routeUrl.href, "_blank");
    };
    // 关闭定时器
    onUnmounted(() => {
      window.removeEventListener("scroll", onscrolla);
    });

    return {
      activeName,
      handleClick,
      news_l,
      fnJumpDetailsPage,
      load,
      loading,
      noMore,
    };
  },
};
</script>
<style scoped lang="less">
.gWidth {
  // background: #fff;
  width: 1100px;

  .sticky {
    // padding: 0 20px;
    background: #f2f2f2;
    position: sticky;
    top: 0;
    z-index: 999;
  }
}

.el-card {
  width: 1100px;
  margin: 10px auto;
  // margin: 10px 0;
  .information {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover h3 {
      color: #409eff;
    }

    &:hover .conter_s {
      color: #606266;
    }

    .information_l {
      width: 15%;
      height: 100px;
      border-radius: 10px;
      overflow: hidden;

      .el-image {
        width: 100%;
        height: 100%;
      }

      .el-empty {
        width: 100%;
        height: 100px;
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    .information_r {
      width: 83%;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      h3 {
        font-weight: 600;
        width: 100%;
        overflow: hidden;
        display: -webkit-box; /**对象作为伸缩盒子模型展示**/
        -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
        -webkit-line-clamp: 1; /**显示的行数**/
      }

      .conter_s {
        height: 20px;
        overflow: hidden;
        display: -webkit-box; /**对象作为伸缩盒子模型展示**/
        -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
        -webkit-line-clamp: 1; /**显示的行数**/
        padding: 10px;
        line-height: 26px;
        background: #eee;
      }
    }
  }

  .pp {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #8c8c8c;
    font-weight: 600;

    .pp_span {
      span {
        margin: 0 10px;
      }
    }
  }
}

.information_box::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}

.information_box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.information_box::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

// .information_box {
//   height: 800px;
// }
.loading {
  color: #8c8c8c;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
</style>
